import styled from "styled-components";

import { MainContainer } from "@/shared/layout/Layout";

export const StyledPMMainContainer = styled(MainContainer)`
    padding: 0;
`;
